export default __webpack_public_path__ + "static/1846-707b65de8e0ad121ab76cdec3676b67e.gif";